import React from 'react';
import { Link } from 'react-router-dom';
import './Menubar.css';
import logo from './assets/SVC_logo_320.png';

function Menubar() {
    return (
        <div className="menubar">
            <img src={logo} alt="Logo" className="logo" />
            <nav>
                <ul>
                    <li><Link to="/">Daten</Link></li>
                    <li><Link to="/top-goalscorers">Tore</Link></li>
                    <li><Link to="/shuffle-teams">Teams</Link></li> {/* New menu item */}
                    <li><Link to="/player-comparison">Vergleich</Link></li> {/* New menu item */}
                </ul>
            </nav>
        </div>
    );
}

export default Menubar;